import { Tag } from "primereact/tag";
import C from "classnames";
import { Tooltip } from "primereact/tooltip";

import { isEmpty } from "sj-ui-toolkit/src/utils";
import { getContentTagForDisplay } from "sj-ui-toolkit/src/atlas/utils";
import { getLessonBadgeSvg } from "sj-ui-toolkit/src/atlas/components/ContentCard/contentCardHelpers";
import {
  ContentType,
  ContentStatus,
} from "sj-ui-toolkit/src/atlas/components/ContentCard/contentCardTypes";

import S from "./LessonCard.module.scss";

interface LessonCardProps {
  contentType: ContentType | undefined;
  points?: number;
  title: string;
  description?: string;
  difficulty?: string;
  estimatedTime?: string;
  progress?: { completed: number; totalLessons: number };
  status?: ContentStatus;
  lessonKey?: string;
  required?: boolean;
}

export const LessonCard = ({
  contentType,
  title,
  description,
  difficulty,
  estimatedTime,
  progress,
  status = "notStarted",
  lessonKey,
  required = true,
}: LessonCardProps) => {
  const badgeSvg = getLessonBadgeSvg(contentType, status);
  const lessonHref = `/lesson/${lessonKey}`;

  return (
    <div className={C(S.lessonCard)}>
      <Tooltip target={`.${S.optionalIcon}`} content="Optional lesson" position="top" />
      <div className={S.lessonCardHeader}>
        <Tag value={getContentTagForDisplay(contentType ?? "")} rounded />
        {!required && <i className={C(S.optionalIcon, "pi pi-lightbulb")} />}
      </div>
      <h4 className={C("atlas-h4", "leading-none")}>{title}</h4>
      <p className={C("body-md", S.description, S.mutedText)}>{description}</p>
      <div className={S.lessonDetailsWrapper}>
        {difficulty && (
          <div>
            <p className={C(S.mutedText, "body-sm")}>Difficulty</p>
            <p className="body-md">{difficulty}</p>
          </div>
        )}
        {estimatedTime && (
          <div>
            <p className={C(S.mutedText, "body-sm")}>Estimated Time</p>
            <p className="body-md">~ {estimatedTime} mins</p>
          </div>
        )}
        {progress && !isEmpty(progress) && (
          <div>
            <p className={C(S.mutedText, "body-sm")}>Progress</p>
            <p className="body-md">
              {progress.completed}/{progress.totalLessons} Tasks
            </p>
          </div>
        )}
      </div>
      <div className={S.lessonCardFooter}>
        <a href={lessonHref} className="p-button">
          Preview
        </a>
      </div>
      {badgeSvg && (
        <div className={S.badgeSvgWrapper}>
          <img src={badgeSvg} alt={`${contentType} badge`} />
        </div>
      )}
    </div>
  );
};
